<template>
    <vue-folder-button
            tabindex="0"
            :icon-class="value?'fa-eye':'fa-pencil'"
            @click.native="toggle"
            aria-label="Toggle Edit Mode"
            role="button"
    ></vue-folder-button>
</template>

<script>
    export default {
        name: "ToggleEditModeButton",
        props: {
            value: Boolean,
        },
        methods: {
            toggle() {
                this.$emit('input', !this.value);
            }
        }
    };
</script>
